.card {
    min-height: 236px;
    padding: 14px 14px 20px 14px;
    background-color: var(--bg-light);
    border: 1px solid var(--border);
    border-radius: 6px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    cursor: pointer;
    display: flex;
    flex-direction: column;
    transition:
        transform 0.1s ease,
        box-shadow 0.1s ease;
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.25);
}

.card > img {
    width: 142px;
    height: 142px;
}

.card > span {
    padding-top: 20px;
    font-size: 16px;
}

@media (max-width: 456px) {
    .card {
        min-height: 100%;
    }

    .card > img {
        width: 100%;
        height: auto;
        aspect-ratio: 1 / 1;
    }
}
